import listenerMiddleware from "App/listenerMiddleware";
import { actionTypes as signalRActionTypes } from "Areas/SharedFeatures/signalRMiddleware";
import { getActiveDocumentId, getSelectedDocumentIds } from "Areas/Sidebar/Documents/redux/getActiveDocumentId";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import forEach from "lodash/forEach";
import groupBy from "lodash/groupBy";
import includes from "lodash/includes";
import keyBy from "lodash/keyBy";
import pick from "lodash/pick";
import values from "lodash/values";
import { v4 as uuid } from "uuid";
import { NAMESPACE } from "../constants";
import actionCreators from "./actionCreators";
import actionTypes from "./actionTypes";
import reduxStoreExternal from "./reduxStoreExternal";
export const initialState = {
    [NAMESPACE]: {
        sourceDataKey: {},
        deleted: [],
        contentKey: {},
        detailedPanelOpen: undefined,
        contentMasterNodes: {},
        contentGroupNodes: {},
        socialComments: {},
        socialLikes: {},
        isWaitingComments: {},
        isWaitingLikes: {}
    }
};
const setContentDataForDocument = (state, payload, documentId) => {
    const nodesMap = keyBy(payload.Nodes, "NodeId");
    const content = {};
    forEach(payload.Content, c => {
        if (!c.NodeId || !c.MasterNodeId)
            return;
        content[c.Id] = {
            ...c,
            NodeSource: c.NodeId ? nodesMap[c.NodeId] : undefined,
            MasterNodeSource: c.MasterNodeId ? nodesMap[c.MasterNodeId] : undefined
        };
    });
    reduxStoreExternal.sourceData[documentId] = {
        Id: payload.Id,
        Content: values(content),
        Nodes: payload.Nodes
    };
    reduxStoreExternal.content[documentId] = content;
    let result = set(state, `[${NAMESPACE}].sourceDataKey[${documentId}]`, uuid());
    result = set(result, `[${NAMESPACE}].contentKey[${documentId}]`, uuid());
    result = set(result, `[${NAMESPACE}].deleted`, []);
    return result;
};
export default createReducer(initialState, {
    [actionTypes.SET_WAIT_COMMENTS]: (state, { nodeId, documentId, is }) => set(state, `[${NAMESPACE}].isWaitingComments[${documentId}][${nodeId}]`, is),
    [actionTypes.SET_WAIT_LIKES]: (state, { nodeId, documentId, is }) => set(state, `[${NAMESPACE}].isWaitingLikes[${documentId}][${nodeId}]`, is),
    [actionTypes.SET_SOCIAL_COMMENTS]: (state, { meta }) => {
        let result = state;
        if (meta.sourceData) {
            result = set(result, `[${NAMESPACE}].socialComments[${meta.documentId}][${meta.postNodeId}]`, meta.sourceData);
        }
        if (!meta.sourceData || meta.sourceData.length > 0) {
            result = set(result, `[${NAMESPACE}].isWaitingComments[${meta.documentId}][${meta.postNodeId}]`, false);
        }
        return result;
    },
    [actionTypes.SET_SOCIAL_LIKES]: (state, { meta }) => {
        let result = state;
        if (meta.sourceData) {
            result = set(result, `[${NAMESPACE}].socialLikes[${meta.documentId}][${meta.postNodeId}]`, meta.sourceData);
        }
        if (!meta.sourceData || meta.sourceData.length > 0) {
            result = set(result, `[${NAMESPACE}].isWaitingLikes[${meta.documentId}][${meta.postNodeId}]`, false);
        }
        return result;
    },
    [actionTypes.SET_CONTENT_CHILDREN_FOR_DOCUMENT]: (state, { meta }) => {
        let result = state;
        const groupsByDocumentObjectId = groupBy(meta.sourceData, "DocumentObjectId");
        forEach(groupsByDocumentObjectId, (nodes, documentObjectId) => {
            result = set(result, `[${NAMESPACE}].contentGroupNodes[${meta.documentId}][${meta.nodeId}][${documentObjectId}]`, keyBy(nodes, "NodeId"));
        });
        return result;
    },
    [actionTypes.SET_CONTENT_MASTERS_FOR_DOCUMENT]: (state, { meta }) => set(state, `[${NAMESPACE}].contentMasterNodes[${meta.documentId}]`, keyBy(meta.sourceData, "NodeId")),
    [actionTypes.SET_CONTENT_DATA_FOR_DOCUMENT]: (state, { meta }) => setContentDataForDocument(state, meta.sourceData, meta.documentId),
    [actionTypes.UPDATE_CONTENT_DATA]: (state, { documentId, data }) => {
        if (!reduxStoreExternal.content[documentId])
            return state;
        forEach(data, e => {
            reduxStoreExternal.content[documentId][e.Id] = e;
        });
        return set(state, `[${NAMESPACE}].contentKey[${documentId}]`, uuid());
    },
    [actionTypes.SET_DELETED]: (state, { ids }) => set(state, `[${NAMESPACE}].deleted`, ids),
    [actionTypes.SET_DETAILED_PANEL_OPEN]: (state, { detailedPanelOpen }) => set(state, `[${NAMESPACE}].detailedPanelOpen`, detailedPanelOpen),
    [actionTypes.CLEAR_DATA]: (state, { exceptDocumentId }) => {
        if (exceptDocumentId) {
            reduxStoreExternal.sourceData = pick(reduxStoreExternal.sourceData, exceptDocumentId);
            reduxStoreExternal.content = pick(reduxStoreExternal.content, exceptDocumentId);
            return {
                ...state,
                [NAMESPACE]: {
                    ...state[NAMESPACE],
                    sourceDataKey: pick(state[NAMESPACE].sourceDataKey, exceptDocumentId),
                    contentKey: pick(state[NAMESPACE].contentKey, exceptDocumentId)
                }
            };
        }
        reduxStoreExternal.sourceData = {};
        reduxStoreExternal.content = {};
        return {
            ...state,
            ...initialState
        };
    }
});
listenerMiddleware.addListener({
    [signalRActionTypes.SOCIAL_COMMENT_TASK_COMPLETED.redux]: ({ message }, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (message.documentId && includes(selectedDocumentIds, message.documentId)) {
            if (!message.isEmpty)
                dispatch(actionCreators.getComments(message.postNodeId, message.documentId));
        }
        dispatch(actionCreators.setWaitingComments(message.postNodeId, message.documentId, false));
    },
    [signalRActionTypes.SOCIAL_LIKE_TASK_COMPLETED.redux]: ({ message }, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (message.documentId && includes(selectedDocumentIds, message.documentId)) {
            if (!message.isEmpty)
                dispatch(actionCreators.getLikes(message.postNodeId, message.documentId));
        }
        dispatch(actionCreators.setWaitingLikes(message.postNodeId, message.documentId, false));
    },
    [actionTypes.GET_COMMENTS_COMPLETED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_SOCIAL_COMMENTS,
                meta: {
                    postNodeId: action.meta.nodeId,
                    documentId: action.meta.documentId,
                    sourceData: action.payload
                }
            });
        }
    },
    [actionTypes.GET_COMMENTS_REJECTED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_SOCIAL_COMMENTS,
                meta: {
                    postNodeId: action.meta.nodeId,
                    documentId: action.meta.documentId,
                    sourceData: undefined
                }
            });
        }
    },
    [actionTypes.GET_LIKES_COMPLETED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_SOCIAL_LIKES,
                meta: {
                    postNodeId: action.meta.nodeId,
                    documentId: action.meta.documentId,
                    sourceData: action.payload
                }
            });
        }
    },
    [actionTypes.GET_LIKES_REJECTED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_SOCIAL_LIKES,
                meta: {
                    postNodeId: action.meta.nodeId,
                    documentId: action.meta.documentId,
                    sourceData: undefined
                }
            });
        }
    },
    [actionTypes.GET_DOCUMENT_CONTENT_CHILDREN_COMPLETED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_CONTENT_CHILDREN_FOR_DOCUMENT,
                meta: {
                    documentId: action.meta.documentId,
                    nodeId: action.meta.nodeId,
                    sourceData: action.payload
                }
            });
        }
    },
    [actionTypes.GET_DOCUMENT_CONTENT_MASTERS_COMPLETED]: (action, dispatch, getState) => {
        const selectedDocumentIds = getSelectedDocumentIds(getState());
        if (includes(selectedDocumentIds, action.meta.documentId)) {
            dispatch({
                type: actionTypes.SET_CONTENT_MASTERS_FOR_DOCUMENT,
                meta: { documentId: action.meta.documentId, sourceData: action.payload }
            });
        }
    },
    [actionTypes.GET_DOCUMENT_CONTENT_DATA_COMPLETED]: (action, dispatch, getState) => {
        const activeDocument = getActiveDocumentId(getState());
        dispatch(actionCreators.clearData(activeDocument));
        if (activeDocument === action.meta.documentId) {
            dispatch({
                type: actionTypes.SET_CONTENT_DATA_FOR_DOCUMENT,
                meta: { documentId: action.meta.documentId, sourceData: action.payload }
            });
        }
    },
    [actionTypes.SAVE_DOCUMENT_CONTENT_DATA_COMPLETED]: (action, dispatch, getState) => {
        const activeDocument = getActiveDocumentId(getState());
        dispatch(actionCreators.clearData(activeDocument));
        if (activeDocument === action.meta.documentId) {
            dispatch({ type: actionTypes.SET_CONTENT_DATA_FOR_DOCUMENT, meta: action.meta });
        }
    }
});
